<!--
<template>
    <main-content>
        <kt-panel>
            <kt-panel-body >
                <form v-if="status === 'success'" class="kt-form" @submit.prevent="update">
                    <kt-form-section>
                        <kt-form-row>
                            <kt-col lg="4" md="4" sm="12">
                                <kt-form-group>
                                    <kt-form-label for="national_code">
                                        {{ $t('label.current_password') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            dir="ltr"
                                            type="password"
                                            name="current_password"
                                            id="current_password"
                                            v-model="user.password"
                                            @change="isChangePass"
                                    ></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="4" md="4" sm="12">
                                <kt-form-group>
                                    <kt-form-label for="national_code">
                                        {{ $t('label.new_password') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            dir="ltr"
                                            type="password"
                                            name="new_password"
                                            id="new_password"
                                            v-model="user.new_password"
                                            autocomplete="off"
                                            disabled
                                    ></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="4" md="4" sm="12">
                                <kt-form-group>
                                    <kt-form-label for="national_code">
                                        {{ $t('label.confirm_new_password') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            dir="ltr"
                                            type="password"
                                            name="new_password_confirm"
                                            id="new_password_confirm"
                                            v-model="user.new_password_confirm"
                                            autocomplete="off"
                                            disabled
                                    ></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                        </kt-form-row>
                    </kt-form-section>

                    <kt-form-action class="mt-4">
                        <button class="btn btn-md btn-success btn-wide" type="submit" id="submit_btn">
                            {{ $t('btn.submit') }}
                        </button>
                    </kt-form-action>
                </form>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
    import mainContent from './Base'
    import $ from 'jquery'
    import { mapState } from 'vuex'
    import { KTApp } from '@/plugins/core/app'
    import { KTUtil } from '@/plugins/core/util'
    import { userService } from '@/common/api.service'
    import Inputmask from 'inputmask'
    import {i18n} from "@/plugins/i18n";

    export default {
        name: 'profile.update',
        components: {
            'main-content': mainContent,
        },
        data: function() {
            return {
                user: this.$store.state.user.current_user,
            }
        },
        computed: {
            ...mapState('user', {
                status: state => state.status,
            })
        },
        watch: {
            status() {
                this.user = this.$store.state.user.current_user
            }
        },
        beforeRouteEnter (to, from, next) {
            next(vm => vm.$store.dispatch('user/fetchCurrent'))
        },
        mounted() {
            this.$nextTick(function () {
                this.initialSetup()
            })
        },
        methods: {
            isChangePass() {
                if ($('#current_password').val().length > 0) {
                    document.getElementById("new_password").disabled = false;
                    document.getElementById("new_password_confirm").disabled = false;
                } else {
                    document.getElementById("new_password").disabled = true;
                    document.getElementById("new_password_confirm").disabled = true;
                }
            },
            initialSetup() {
                setTimeout(() => {
                    if(!this.$refs.selectPicker) {
                        return
                    }
                    let selects = $(this.$refs.selectPicker.$el).find('.kt-selectpicker')
                    $(selects).selectpicker({
                        size: 5
                    })

                    Inputmask('099-99999999').mask(this.$refs.telephone.$el)
                }, 1000)

            },
            update(e) {
                let form = $(e.target)
                let btn = $('#submit_btn')
                let current_password = $('#current_password').val()

                function isPasswordChange() {
                    return current_password.length > 0;
                }
                form.validate({
                    ignore: ":hidden",

                    rules: {
                        new_password : {
                            required: isPasswordChange,
                            minlength : {
                                depends: isPasswordChange,
                                param: 6
                            }
                        },
                        new_password_confirm : {
                            required: isPasswordChange,
                            equalTo : "#new_password"
                        }
                    },
                });


                if(!form.valid()) {
                    return
                }

                if (!this.validateSocialId(this.user.national_code)) {
                    form.validate().showErrors({
                        national_code: i18n.t('validation.invalid_national_code')
                    })
                    return;
                }

                let params = {
                    current_password: current_password,
                    new_password: $('#new_password').val(),
                }

                KTApp.progress(btn)
                userService.update(params)
                    .then(response => {
                        this.$store.commit('user/success', response.data.data)
                        this.showMsg(form, 'success', response.data.message)
                    })
                    .catch(({response}) => {
                        if(response.data) {
                            form.validate().showErrors(response.data.data)
                        }
                        this.showMsg(form, 'danger', response.data.message)
                    })
                    .finally(() => {
                        KTUtil.scrollTop()
                        KTApp.unprogress(btn)
                    })
            },
            getYear() {
                return new Date().getFullYear() - 721
            },
            validateSocialId(social_id) {
                var L=social_id.length;

                if(L<8 || parseInt(social_id,10)==0) return false;
                social_id=('0000'+social_id).substr(L+4-10);
                if(parseInt(social_id.substr(3,6),10)==0) return false;
                var c=parseInt(social_id.substr(9,1),10);
                var s=0;
                for(var i=0;i<9;i++)
                    s+=parseInt(social_id.substr(i,1),10)*(10-i);
                s=s%11;
                return (s<2 && c==s) || (s>=2 && c==(11-s));
            },
        }
    }
</script>

<style>
    .kt-nav .kt-nav__item > .router-link-exact-active {
        background-color: #f7f8fa!important;
    }
    .router-link-exact-active > .kt-nav__link-icon,
    .router-link-exact-active > .kt-nav__link-text {
        color: #5d78ff!important;
    }
</style>

-->
<template>
    <main-content>
        <kt-panel>
            <kt-panel-body >
                <form v-if="status === 'success'" class="kt-form" @submit.prevent="update" >
                    <kt-form-section>
                        <kt-form-row>
                            <kt-col lg="4" md="4" sm="12">
                                <kt-form-group>
                                    <kt-form-label for="national_code">
                                        {{ $t('label.current_password') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            dir="ltr"
                                            type="password"
                                            name="current_password"
                                            id="current_password"
                                            v-model="user.password"
                                            @change="isChangePass"
                                    ></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="4" md="4" sm="12">
                                <kt-form-group>
                                    <kt-form-label for="national_code">
                                        {{ $t('label.new_password') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            dir="ltr"
                                            type="password"
                                            name="new_password"
                                            id="new_password"
                                            v-model="user.new_password"
                                            autocomplete="off"
                                            disabled
                                    ></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="4" md="4" sm="12">
                                <kt-form-group>
                                    <kt-form-label for="national_code">
                                        {{ $t('label.confirm_new_password') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            dir="ltr"
                                            type="password"
                                            name="new_password_confirm"
                                            id="new_password_confirm"
                                            v-model="user.new_password_confirm"
                                            autocomplete="off"
                                            disabled
                                    ></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                        </kt-form-row>
                    </kt-form-section>

                    <kt-form-action class="mt-4">
                        <button class="btn btn-md btn-success btn-wide" type="submit" id="submit_btn">
                            {{ $t('btn.submit') }}
                        </button>
                    </kt-form-action>
                </form>
            </kt-panel-body>
        </kt-panel>

<!--        <kt-panel>-->
<!--            <kt-panel-body >-->
<!--                <form class="kt-form" @submit.prevent="updateSetting" >-->
<!--                <kt-form-section>-->
<!--                    <kt-form-row>-->
<!--                        <kt-col lg="4" md="4" sm="12">-->
<!--                            <kt-form-label for="has_two_factor_auth">-->
<!--                                {{ $t('label.two_factor_auth_title') }}-->
<!--                            </kt-form-label>-->

<!--                            <kt-form-group>-->
<!--                                <kt-form-check-->
<!--                                    id="has_two_factor_auth"-->
<!--                                    name="has_two_factor_auth"-->
<!--                                    v-model="form_data.has_two_factor_auth"-->
<!--                                >-->
<!--                                    {{ $t('label.two_factor_auth') }}-->
<!--                                </kt-form-check>-->
<!--                            </kt-form-group>-->
<!--                        </kt-col>-->
<!--                    </kt-form-row>-->
<!--                </kt-form-section>-->

<!--                <kt-form-action class="mt-4">-->
<!--                    <button class="btn btn-md btn-success btn-wide" type="submit" id="setting_btn">-->
<!--                        {{ $t('btn.update') }}-->
<!--                    </button>-->
<!--                </kt-form-action>-->
<!--            </form>-->
<!--            </kt-panel-body>-->
<!--        </kt-panel>-->
    </main-content>
</template>

<script>
    import mainContent from './Base'
    import $ from 'jquery'
    import { mapState } from 'vuex'
    import { KTApp } from '@/plugins/core/app'
    import { KTUtil } from '@/plugins/core/util'
    import { userService } from '@/common/api.service'
    import Inputmask from 'inputmask'
    import {i18n} from "@/plugins/i18n";

    export default {
        name: 'profile.change-password',
        components: {
            'main-content': mainContent,
        },
        data: function() {
            return {
                user: this.$store.state.user.current_user,
                form_data: {
                    has_two_factor_auth: false
                }
            }
        },
        computed: {
            ...mapState('user', {
                status: state => state.status,
            }),
        },
        watch: {
            status() {
                this.user = this.$store.state.user.current_user
            }
        },
        beforeRouteEnter (to, from, next) {
            next(vm => vm.$store.dispatch('user/fetchCurrent'))
        },
        mounted() {
            this.$nextTick(function () {
                this.initialSetup()
            })
            this.getSettings();
        },
        methods: {
            isChangePass() {
                if ($('#current_password').val().length > 0) {
                    document.getElementById("new_password").disabled = false;
                    document.getElementById("new_password_confirm").disabled = false;
                } else {
                    document.getElementById("new_password").disabled = true;
                    document.getElementById("new_password_confirm").disabled = true;
                }
            },
            initialSetup() {
                setTimeout(() => {
                    if(!this.$refs.selectPicker) {
                        return
                    }
                    let selects = $(this.$refs.selectPicker.$el).find('.kt-selectpicker')
                    $(selects).selectpicker({
                        size: 5
                    })

                    Inputmask('099-99999999').mask(this.$refs.telephone.$el)
                }, 1000)

            },
            update(e) {
                let form = $(e.target)
                let btn = $('#submit_btn')

                let current_password = $('#current_password').val()

                function isPasswordChange() {
                    return current_password.length > 0;
                }

                form.validate({
                    ignore: ":hidden",

                    rules: {
                        current_password : {
                            required: true,
                            minlength : {
                                param: 6
                            }
                        },
                        new_password : {
                            required: isPasswordChange,
                            minlength : {
                                depends: isPasswordChange,
                                param: 6
                            }
                        },
                        new_password_confirm : {
                            required: isPasswordChange,
                            equalTo : "#new_password"
                        }
                    },
                });

                if(!form.valid()) {
                    return
                }

                let params = {
                    current_password: current_password,
                    new_password: $('#new_password').val(),
                }

                KTApp.progress(btn)
                userService.changePassword(params)
                    .then(response => {
                        this.$store.commit('user/success', response.data.data)
                        this.showMsg(form, 'success', response.data.message)

                    })
                    .catch(({response}) => {
                        if(response.data) {
                            form.validate().showErrors(response.data.data)
                        }
                        this.showMsg(form, 'danger', response.data.message)
                    })
                    .finally(() => {
                        KTUtil.scrollTop()
                        KTApp.unprogress(btn)
                        $("#current_password").val('')
                        $("#new_password").val('')
                        $("#new_password_confirm").val('')
                    })

            },

            updateSetting(e) {
                let btn = $("#setting_btn");

                KTApp.progress(btn)

                userService.userSetting(this.form_data)
                    .then((response) => {
                        this.toastr.success(i18n.t('label.updated'));
                        KTApp.unprogress(btn)
                    }).catch((error) => {
                    this.toastr.error(i18n.t('dropzone.dict_response_error'));
                    KTApp.unprogress(btn)

                }).finally(() => {
                    KTApp.unprogress(btn)
                });
            },

            getSettings() {
                userService.getUserSetting()
                    .then(({data}) => {
                        this.form_data= data.data;
                    })
            },

        }
    }
</script>

<style>
    .kt-nav .kt-nav__item > .router-link-exact-active {
        background-color: #f7f8fa!important;
    }
    .router-link-exact-active > .kt-nav__link-icon,
    .router-link-exact-active > .kt-nav__link-text {
        color: #5d78ff!important;
    }

    .kt-checkbox > span:after {
         border: solid #2f333b !important;
    }

    .kt-checkbox > input:checked ~ span {
        border: 1px solid #2f333b !important;
    }

</style>
